import React, { useEffect, useState } from "react";

import { Listbox } from "@headlessui/react";

import "./styles.scss";
import ArrowDownIcon from "assets/images/components/ArrowDownIcon";

const Select = ({
  className = undefined,
  name = undefined,
  selectData,
  onSelect,
  selectLabel = "",
  defaultValue = undefined,
}) => {
  const [selectedOption, setSelectedOption] = useState(selectData[0]);
  const uniqueName = `select-Math.random()`;
  useEffect(() => {
    if (defaultValue) {
      setSelectedOption(defaultValue);
    }
  }, []);
  useEffect(() => {
    onSelect(selectedOption);
  }, [selectedOption]);
  if (!selectData) return;

  return (
    <div className={`${className ? className : ""} select__wrapper`}>
      <div className="select__label">{selectLabel}</div>
      <Listbox
        name={name}
        value={selectedOption}
        onChange={(selectedOption) => {
          setSelectedOption(selectedOption);
        }}
      >
        <Listbox.Button className="select__trigger">
          <span className="select__input">{selectedOption.Label}</span>
          <ArrowDownIcon />
        </Listbox.Button>

        <Listbox.Options className="select__list">
          {selectData.map((data, index) =>
            <Listbox.Option key={`${uniqueName}-${data.Value}-${index}}`} value={data}>
              {data.Label}
            </Listbox.Option>
          )
          }
        </Listbox.Options>
      </Listbox>
    </div>
  );
};
export default Select;
